<template>
	<div class="change-password inline-block">
		<div
			class="inline-block"
			@click="show"
		>
			<slot></slot>
		</div>
		<el-dialog
			class="page-dialog-wrapper"
			v-if="dialogleVisible"
			title="修改密码"
			width="480px"
			:visible.sync="dialogleVisible"
			append-to-body
			@close="closePop"
		>
			<el-form
				ref="ruleForm"
				:model="form"
				label-width="110px"
				:rules="rules"
			>
				<el-form-item
					label="输入旧密码："
					prop="oldPassword"
				>
					<el-input
						v-model="form.oldPassword"
						placeholder="请输入旧密码"
						type="password"
					></el-input>
				</el-form-item>
				<el-form-item
					label="输入新密码："
					prop="newPassword"
				>
					<el-input
						v-model="form.newPassword"
						placeholder="最少输入6位数字/字母，不可输入特殊字符"
						type="password"
					></el-input>
				</el-form-item>
				<el-form-item
					label="确认新密码："
					prop="confirmPassword"
					:class="{err:flag}"
				>
					<el-input
						v-model="form.confirmPassword"
						placeholder="最少输入6位数字/字母，不可输入特殊字符"
						type="password"
						@change="changePassword"
					></el-input>
					<span
						class="err_text"
						v-if="flag"
					>两次输入密码不一致</span>
				</el-form-item>
			</el-form>
			<span
				slot="footer"
				class="dialog-footer"
			>
				<el-button @click="closePop">取消</el-button>
				<el-button
					type="primary"
					@click="savePassword"
				>提交</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				flag: false,
				dialogleVisible: false,
				form: {
					newPassword: "", //新密码
					oldPassword: "", //旧密码
          confirmPassword: "", //确认密码
          source: 'PS', // 数据源（暂时写死）
          ifEncrypt: true
				},
				rules: {
					oldPassword: [
						{
							required: true,
							message: "请输入旧密码",
							trigger: "blur"
						},
						{
							pattern: /^[A-Za-z0-9]\w{5,15}$/,
							message: "输入6-16位数字或字母，不可输入特殊字符",
							trigger: "blur"
						}
					],
					newPassword: [
						{
							required: true,
							message: "请输入新密码",
							trigger: "blur"
						},
						{
							pattern: /^[A-Za-z0-9]\w{5,15}$/,
							message: "输入6-16位数字或字母，不可输入特殊字符",
							trigger: "blur"
						}
					],
					confirmPassword: [
						{
							required: true,
							message: "请确认新密码",
							trigger: "blur"
						},
						{
							pattern: /^[A-Za-z0-9]\w{5,15}$/,
							message: "输入6-16位数字或字母，不可输入特殊字符",
							trigger: "blur"
						}
					]
				}
			};
		},
		methods: {
			show(){
				this.dialogleVisible = true;
      },
			//保存
			savePassword() {
				if (this.form.confirmPassword !== this.form.newPassword) {
					this.flag = true;
				} else {
					this.flag = false;
				}
				this.$refs["ruleForm"].validate(valid => {
					if (valid) {
						if (!this.flag) {
              const { newPassword, oldPassword, source, ifEncrypt } = this.form;
              // let formData = {...this.form}
              let formData = { newPassword, oldPassword, source, ifEncrypt };
							formData.newPassword = this.AES.Encrypt(formData.newPassword)
							formData.oldPassword = this.AES.Encrypt(formData.oldPassword)
							this.$api.personalModifyPass(formData).then(() => {
								this.closePop();
								this.$store.dispatch('doLogout'); // 改为store的退出
							});
						} else {
							return false;
						}
					} else {
						return false;
					}
				});
			},
			changePassword(){
				if (this.form.confirmPassword !== this.form.newPassword) {
					this.flag = true;
				} else {
					this.flag = false;
				}
			},
			/**
			 * 关闭弹窗
			 */
			closePop() {
				this.dialogleVisible = false;
				this.$emit("close");
			}
		}
	};
</script>
<style lang="scss">
  .change-password {
    .el-dialog__header {
      padding: 20px;
      padding-bottom: 10px;
      background: #f5f6f9;
      border-bottom: 1px #ccc solid;
    }
    .err {
      position: relative;
      .el-input__inner {
        border-color: #f56c6c;
      }
      .err_text {
        position: absolute;
        top: 30px;
        left: 0;
        font-size: 12px;
        color: #f56c6c;
      }
    }
    .is-error{
      .err_text{
        display: none;
      }
    }
    .is-success{
      .err_text{
        display: block;
      }
    }
  }
	/*.el-dialog__header {*/
			/*background-color: #D2E0F6;*/
		/*}*/
		/*.el-dialog__body,.el-dialog__footer {*/
			/*background-color:#DFEBFF;*/
		/*}*/
</style>
